import PropTypes from "prop-types";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";

class NonAuthLayout extends Component {
  constructor(props) {
    super(props);
    this.state = { mounted: false };
    this.capitalizeFirstLetter.bind(this);
  }

  capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  componentDidMount() {
    this.setState({ mounted: true });
    let currentage = this.capitalizeFirstLetter(this.props.location.pathname);

    document.title = currentage + " | Fast Parking";

    document.querySelector("body").classList.add("auth-body");
  }

  componentWillUnmount() {
    document.querySelector("body").classList.remove("auth-body");
  }

  render() {
    return <React.Fragment>{this.props.children}</React.Fragment>;
  }
}

NonAuthLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
};

export default withRouter(NonAuthLayout);
